var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5Star(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 45,
    viewBox: "0 0 241 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M22.5 0L29.2448 13.2165L43.8988 15.5471L33.4134 26.046L35.7252 40.7029L22.5 33.975L9.27483 40.7029L11.5866 26.046L1.10123 15.5471L15.7552 13.2165L22.5 0Z",
    fill: "#E0866A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 2",
    d: "M71.5 0L78.2448 13.2165L92.8988 15.5471L82.4134 26.046L84.7252 40.7029L71.5 33.975L58.2748 40.7029L60.5866 26.046L50.1012 15.5471L64.7552 13.2165L71.5 0Z",
    fill: "#E0866A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 4",
    d: "M169.5 0L176.245 13.2165L190.899 15.5471L180.413 26.046L182.725 40.7029L169.5 33.975L156.275 40.7029L158.587 26.046L148.101 15.5471L162.755 13.2165L169.5 0Z",
    fill: "#E0866A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 3",
    d: "M120.5 0L127.245 13.2165L141.899 15.5471L131.413 26.046L133.725 40.7029L120.5 33.975L107.275 40.7029L109.587 26.046L99.1012 15.5471L113.755 13.2165L120.5 0Z",
    fill: "#E0866A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 5",
    d: "M218.5 0L225.245 13.2165L239.899 15.5471L229.413 26.046L231.725 40.7029L218.5 33.975L205.275 40.7029L207.587 26.046L197.101 15.5471L211.755 13.2165L218.5 0Z",
    fill: "#E0866A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Star);
export default __webpack_public_path__ + "static/media/5star.bf3890619830c1daaa1023615f641cfb.svg";
export { ForwardRef as ReactComponent };